/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const PeopleGroupIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'People Group',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M13.01758,13.27148c-1.97949,0-3.58984-1.69043-3.58984-3.76758s1.61035-3.76758,3.58984-3.76758,3.58984,1.69043,3.58984,3.76758-1.61035,3.76758-3.58984,3.76758ZM13.01758,7.23633c-1.15234,0-2.08984,1.01758-2.08984,2.26758s.9375,2.26758,2.08984,2.26758,2.08984-1.01758,2.08984-2.26758-.9375-2.26758-2.08984-2.26758Z"
      fill="currentColor"
    />
    <path
      d="M7.87109,18.97266c-.02734,0-.05469-.00098-.08203-.00391-.41113-.04492-.70898-.41504-.66504-.82715.26074-2.40527,2.79395-4.21973,5.89355-4.21973,3.07617,0,5.66504,1.85742,5.89355,4.22852.04004.41211-.26172.7793-.67383.81836-.4082.04688-.7793-.26172-.81836-.67383-.15332-1.58398-2.12793-2.87305-4.40137-2.87305-2.29395,0-4.22656,1.26562-4.40137,2.88184-.04199.38379-.36719.66895-.74512.66895Z"
      fill="currentColor"
    />
    <path
      d="M3.83301,16.33887c-.02734,0-.05371-.00098-.08105-.00391-.41211-.04492-.70996-.41504-.66602-.82617.23047-2.13672,2.2832-3.85059,4.99219-4.16797.4043-.0459.7832.24707.83203.6582.04785.41113-.24609.7832-.6582.83203-1.97656.23145-3.52148,1.4248-3.67383,2.83789-.04199.38477-.36719.66992-.74512.66992Z"
      fill="currentColor"
    />
    <path
      d="M.82031,13.44336c-.02734,0-.05371-.00098-.08105-.00391-.41211-.04492-.70996-.41504-.66602-.82617.21387-1.97949,2.10938-3.56543,4.60938-3.8584.40332-.04688.7832.24707.83203.6582.04785.41113-.24609.78418-.6582.83203-1.77148.20703-3.15527,1.27051-3.29102,2.52832-.04199.38477-.36719.66992-.74512.66992Z"
      fill="currentColor"
    />
    <path
      d="M7.56543,9.64844c-.20703,0-.41309-.08496-.56055-.25195-.58398-.6582-.92578-1.51465-.96289-2.41211-.08691-2.0752,1.45215-3.83105,3.42969-3.91309.4502-.02148.89062.0498,1.31445.20215.38965.13965.59082.57031.4502.95996-.13965.38867-.56836.58887-.95996.4502-.23828-.08496-.49023-.12109-.74316-.11426-1.15039.04883-2.04492,1.10352-1.99316,2.35254.02344.55371.23145,1.0791.58594,1.47852.27539.30957.24707.78418-.0625,1.05859-.14258.12695-.32031.18945-.49805.18945Z"
      fill="currentColor"
    />
    <path
      d="M3.95117,7.25391c-.19141,0-.38281-.07227-.52832-.21777-.87109-.86523-1.20898-2.31445-.82324-3.52539.54785-1.71875,2.28809-2.74902,3.95996-2.34668.40234.09766.65039.50293.55371.90527-.09766.40332-.50684.64746-.90527.55371-.91602-.2207-1.86816.37109-2.17871,1.34375-.21191.66309-.01367,1.54395.4502,2.00488.29395.29199.2959.76758.00391,1.06055-.14648.14746-.33984.22168-.53223.22168Z"
      fill="currentColor"
    />
  </svg>`;
};
